import Pagination from 'rc-pagination/lib/locale/zh_CN';
export default {
    locale: 'zh-cn',
    Pagination,
    global: {
        placeholder: '请选择',
    },
    Icon: {
        icon: '图标',
    },
};
